import styled from 'styled-components'

export const Container = styled.div`
  padding: 0 20px;

  & > *:last-of-type > div {
    margin-bottom: 0;
  }
`
